<template>
  <router-link
    v-if="navType === 'innerRouter'"
    :class="{
      'base-gold-btn': true,
      'gradient-border': styleType === 'gradient'
    }"
    :to="url"
    ><slot></slot
  ></router-link>
  <a
    v-else-if="navType === 'zendesk'"
    href="#"
    :class="{
      'base-gold-btn': true,
      'gradient-border': styleType === 'gradient'
    }"
    @click.prevent="toggleZendesk(true)"
    ><slot></slot
  ></a>
  <a v-else :href="url" target="_blank" class="demo-btn"><slot></slot></a>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "GoldButton",
  props: {
    styleType: [String],
    navType: [String],
    url: [String]
  },
  methods: {
    ...mapActions(["toggleZendesk"])
  }
};
</script>

<style scoped lang="scss">
.base-gold-btn {
  $btn-color: #c5ab80;
  $btn-color-light: mix(#fff, $btn-color, 75%);

  border: 0.125rem solid currentColor;
  color: $btn-color;
  display: block;
  width: 17.5625rem;
  height: 4.5rem;
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
  line-height: 4.5rem;
  transition: 0.2s ease-in-out;

  &:hover,
  &:focus {
    box-shadow: inset 0 0 0 2.25rem $btn-color-light;
  }
}
.gradient-border {
  border-image-source: linear-gradient(256deg, #f2e8d2 50%, #534835);
  border-image-slice: 1;
}
.demo-btn {
  @extend .base-gold-btn;
  width: 15.1875rem;
}
</style>
